import { render, staticRenderFns } from "./DetailUjian.vue?vue&type=template&id=629198c2"
import script from "./DetailUjian.vue?vue&type=script&lang=js"
export * from "./DetailUjian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports